import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { Button } from '../../UI/Button'
import { ButtonProps } from '../menu/interface/ButtonProps'

interface MenuButtonProps extends ButtonProps {
  onPress: () => void
}

export const MenuButtonV2 = (props: MenuButtonProps) => {
  return (
    <Button
      name="Menu Button"
      defaultView="menu_normal_v2"
      hoverView="menu_hover_v2"
      pressedView="menu_click_v2"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={props.onPress}
    />
  )
}
